import { NgModule } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { AbstractFormsData, ITranslation } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { LanguagesService } from "../providers/languages.service";
import { SessionService } from "../providers/session.service";

@NgModule()
export class FormsData extends AbstractFormsData {
  protected translate(key: string): string {
    return this.translateService.instant(key);
  }
  protected getTranslation(translations: ITranslation, term: string): string {
    return Tools.getTranslation(translations, this.sessionService.userLang, term);
  }
  protected getCurrentLang(): string {
    return this.translateService.currentLang;
  }
  protected getUserLang(): string {
    return this.sessionService.userLang;
  }
  protected getAvailableLangs(): Promise<ITranslation[]> {
    return this.languagesService.list().toPromise();
  }
  constructor(
    private translateService: TranslateService,
    protected sessionService: SessionService,
    protected languagesService: LanguagesService
  ) {
    super();
  }
}
